import { render, staticRenderFns } from "./registerFormColumnsNames.vue?vue&type=template&id=3ff8d448&scoped=true"
import script from "./registerFormColumnsNames.vue?vue&type=script&lang=js"
export * from "./registerFormColumnsNames.vue?vue&type=script&lang=js"
import style0 from "./registerFormColumnsNames.vue?vue&type=style&index=0&id=3ff8d448&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ff8d448",
  null
  
)

export default component.exports